const state = {
    successIds: []
};
const mutations = {
    setSuccessIds: (state:any, ids:Array<string>) => {
        console.log('setSuccessIds', ids);
        state.successIds = ids;
    }
};

export default {
    namespaced: true, // 这个是命名空间，用来区分不同的模块，我是根据文件的名字来区分
    state,
    mutations
};
